import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

export const CITATION_NAME_NOT_UNIQUE_ERROR_MSG: MessageDescriptor = msg`Citation name is already used`;
export const REFERENCE_TABLE_NAME_NOT_UNIQUE_ERROR_MSG: MessageDescriptor = msg`Reference table name is already used`;
